import React from 'react';
import { Helmet } from "react-helmet-async";
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { FaSearch, FaDownload, FaExternalLinkAlt, FaListUl, FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";

const CanalInstalador = () => {
  const cards = [
    {
      title: "VÍDEOS DE INSTALAÇÃO",
      description: "Tutoriais passo a passo para cada linha de produto. Aprenda a instalar corretamente em minutos.",
      buttonText: "Acessar playlist no YouTube",
      icon: <FaListUl />,
      link: "https://www.youtube.com/playlist?list=PLE8AlXj4X5TkUpbYrCMG5ohla4hOVMxzq",
      image: "/media/instalador/bg_video.png"
    },
    {
      title: "MANUAIS DE INSTALAÇÃO",
      description: "Baixe o guia completo do produto e acesse o manual técnico e esquemas FCF para download.",
      buttonText: "Buscar manual por código",
      icon: <FaSearch />,
      link: "/catalogo",
      image: "/media/instalador/bg_manual.png"
    },
    {
      title: "CATÁLOGO TÉCNICO",
      description: "Encontre, profundidade, torque / curva de operação, tipo de fixação: tudo que importa na hora da instalação.",
      buttonText: "Baixar catálogo técnico",
      icon: <FaDownload />,
      link: "/catalogos/SAVEENERGY_Catálogo_2025.pdf",
      image: "/media/instalador/bg_catalogo.png"
    },
    {
      title: "CANAL NO WHATSAPP",
      description: "Grupo exclusivo para instaladores. Tire dúvidas rápidas e troque experiências com outros profissionais.",
      buttonText: "Participar do canal",
      icon: <FaExternalLinkAlt />,
      link: "https://chat.whatsapp.com/JIGAZnuQSG3L3vznGpwfR3",
      image: "/media/instalador/bg_whatsapp.png"
    }
  ];

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Helmet>
        <title>Canal do Instalador | Save Energy</title>
      </Helmet>
      
      <NavBar />

      <main className="flex-1">
        <div className="w-full py-12 bg-[#3c1053] flex flex-col justify-center items-center text-center px-4">
          <h1 className="text-white text-3xl md:text-5xl font-bold mb-4">CANAL DO INSTALADOR</h1>
          <p className="text-white text-lg md:text-xl max-w-2xl">
            Tudo que você precisa para instalar com segurança, agilidade e confiança
          </p>
        </div>

        <div className="max-w-6xl mx-auto px-4 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16">
            {cards.map((card, index) => (
              <div key={index} className="flex flex-col">
                <h2 className="text-[#3c1053] text-xl font-bold mb-4 uppercase">{card.title}</h2>
                <div className="relative rounded-[24px] overflow-hidden h-[280px] mb-6 shadow-md bg-gray-100">
                  <img src={card.image} alt={card.title} className="w-full h-full object-cover" />
                  <div className="absolute bottom-6 left-0 right-0 flex justify-center">
                    <a
                      href={card.link}
                      target={card.link.startsWith('http') ? "_blank" : "_self"}
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 bg-[#890083] hover:bg-[#3c1053] text-white font-bold py-3 px-8 rounded-full transition-colors duration-300 shadow-lg text-sm md:text-base"
                    >
                      {card.icon}
                      {card.buttonText}
                    </a>
                  </div>
                </div>
                <p className="text-gray-700 text-base leading-relaxed pr-4">
                  {card.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="w-full mb-0">
          <div className="relative w-full h-[300px] md:h-[450px] overflow-hidden">
            <video
              className="absolute inset-0 w-full h-full object-cover"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src="/media/instalador/video.mp4" type="video/mp4" />
            </video>
            <div className="absolute inset-0 bg-gray-400/50 backdrop-grayscale-[0.8] pointer-events-none"></div>
          </div>
        </div>

        <div className="w-full bg-[#890083] py-12 flex flex-col items-center justify-center text-center px-4">
          <h3 className="text-white text-xl md:text-2xl font-bold mb-2">
            Conteúdo exclusivo para eletricistas e instaladores
          </h3>
          <p className="text-white opacity-90 mb-8">Siga-nos nas redes sociais</p>
          <div className="flex gap-4">
            <a href="#" className="bg-white text-[#890083] p-3 rounded-full hover:bg-gray-200 transition-colors">
              <FaFacebook size={24} />
            </a>
            <a href="#" className="bg-white text-[#890083] p-3 rounded-full hover:bg-gray-200 transition-colors">
              <FaInstagram size={24} />
            </a>
            <a href="#" className="bg-white text-[#890083] p-3 rounded-full hover:bg-gray-200 transition-colors">
              <FaLinkedin size={24} />
            </a>
            <a href="#" className="bg-white text-[#890083] p-3 rounded-full hover:bg-gray-200 transition-colors">
              <FaYoutube size={24} />
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CanalInstalador;